var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-open-launch-weapp',{attrs:{"username":_vm.username,"id":"wxlink-launch","path":_vm.wxPath},on:{"launch":_vm.handleLaunchFn,"error":_vm.handleErrorFn}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v("\n    <style>\n    .wxlink-box {\n      opacity: 0;\n    }\n    </style>\n    <div class=\"wxlink-box\">测试</div>\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6bb9adc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/wxLink.vue
// module id = null
// module chunks = 